import * as styles from "./RadioGroup.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { RadioGroup as BaseRadioGroup } from "@base-ui/react/radio-group";

import { RadioGroupContext } from "./Radio.context";
import type { RadioGroupProps } from "./Radio.types";

export function RadioGroup({
  orientation,
  layout = "default",
  indicatorPosition = "start",
  align = "start",
  invalid = false,
  className,
  ...props
}: RadioGroupProps): JSX.Element {
  const defaultOrientation =
    layout === "text" || layout === "tile" ? "horizontal" : "vertical";

  return (
    <RadioGroupContext.Provider
      value={{ layout, indicatorPosition, align, invalid }}
    >
      <BaseRadioGroup
        data-slot="radio-group"
        aria-invalid={invalid || undefined}
        className={clsx(
          styles.radioGroup({
            orientation:
              layout === "list"
                ? "vertical"
                : (orientation ?? defaultOrientation),
            layout,
            invalid,
          }),
          className,
        )}
        {...props}
      />
    </RadioGroupContext.Provider>
  );
}
